// extracted by mini-css-extract-plugin
export default {"blockWrapper":"PersonalOfficeMain_blockWrapper__vxf1v","pageContent":"PersonalOfficeMain_pageContent__wskSH"};